import { Reveal, Eyebrow } from "../components/Reveal";

const AREAS = [
  {
    title: "Metabolic Health",
    items: ["Insulin resistance", "Prediabetes & Type 2 diabetes", "Weight management", "Fatty liver", "Dyslipidaemia", "Metabolic syndrome"],
  },
  {
    title: "Hormonal & Reproductive Health",
    items: ["PCOS", "Thyroid-related metabolic concerns", "Hormonal metabolic patterns"],
  },
  {
    title: "Gut & Digestive Health",
    items: ["Bloating", "Irregular bowel habits", "Food-related symptoms", "Functional digestive complaints"],
  },
  {
    title: "Energy, Lifestyle & Longevity",
    items: ["Persistent fatigue", "Poor sleep", "Brain fog", "Stress-related health concerns", "Healthy ageing"],
  },
];

export const Areas = () => (
  <section id="areas" className="bg-ivory grain relative" data-testid="areas-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-32">
      <Reveal className="max-w-2xl">
        <Eyebrow>02 · Areas of focus</Eyebrow>
        <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          What we help with
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
        {AREAS.map((a, i) => (
          <Reveal key={a.title} delay={0.08 * i}>
            <div
              className="group bg-white border border-line p-8 sm:p-10 h-full hover:-translate-y-1 hover:border-gold/60 transition-[transform,border-color] duration-500"
              data-testid={`area-card-${i}`}
            >
              <span className="font-mono text-[11px] tracking-[0.24em] text-gold">0{i + 1}</span>
              <h3 className="mt-4 font-serif text-2xl text-ink">{a.title}</h3>
              <ul className="mt-6 space-y-2.5">
                {a.items.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-sm text-inkmuted">
                    <span className="mt-[7px] h-1 w-1 rotate-45 bg-gold shrink-0" />
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-12 font-serif italic text-xl sm:text-2xl text-forest/85 max-w-2xl leading-snug">
          &ldquo;Not every concern requires a functional medicine protocol. Sometimes the right answer is simpler.&rdquo;
        </p>
      </Reveal>
    </div>
  </section>
);
